import { ISettingInfo, IWritableSettings, ObjectHelper } from '@barthauer/abc/core';

export enum AppSetting {
  lastPublicName,
  lastStyleName,
  arenaStyleSettings,
}

export interface IAppSettings {
  readonly lastPublicName?: string;
  readonly lastStyleName?: string;
  readonly arenaStyleSettings?: string;
}

export class AppSettings implements IAppSettings, IWritableSettings<IAppSettings> {
  public static readonly Infos: ReadonlyMap<AppSetting, ISettingInfo> = new Map<AppSetting, ISettingInfo>([
    [
      AppSetting.lastPublicName,
      {
        settingName: ObjectHelper.nameof<IAppSettings>('lastPublicName'),
        responsePropertyName: ObjectHelper.nameof<IAppSettings>('lastPublicName'),
        settingValueType: String,
      },
    ],
    [
      AppSetting.lastStyleName,
      {
        settingName: ObjectHelper.nameof<IAppSettings>('lastStyleName'),
        responsePropertyName: ObjectHelper.nameof<IAppSettings>('lastStyleName'),
        settingValueType: String,
      },
    ],
    [
      AppSetting.arenaStyleSettings,
      {
        settingName: ObjectHelper.nameof<IAppSettings>('arenaStyleSettings'),
        responsePropertyName: ObjectHelper.nameof<IAppSettings>('arenaStyleSettings'),
        settingValueType: String,
      },
    ],
  ]);

  lastPublicName: string = '';
  lastStyleName: string = 'default';
  arenaStyleSettings: string = '';
  load(settings: IAppSettings): void {
    this.lastPublicName = settings?.lastPublicName ?? '';
    this.lastStyleName = settings?.lastStyleName ?? 'default';
    this.arenaStyleSettings = settings?.arenaStyleSettings ?? '';
  }
}
